import type { RutaProd } from "../../../../runtime/rutas";
export default {
  "ruta": "/sistema/cedis/warehouse/compare",
  "documento": "cedis",
  "acceso": "sesion",
  "filas": [
    "043"
  ],
  "cita": "Areas/CEDIS/Controllers/WarehouseController.cs"
} satisfies RutaProd;
